// ENVIRONMENT
import { environment } from 'src/environments/environment';

// ANGULAR
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';

// ANGULAR MATERIAL
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// RxJS 6
import { Subscription } from 'rxjs';

// API
import {
  FLOW_GATEWAY,
  WHIconENUM,
  WHWorkStepDOM,
} from '@workheld/workheld-shared-lib';

@Component({
  selector: 'ng-bee-mat-dialog-preview-entry',
  templateUrl: './mat-dialog-preview-entry.component.html',
  styleUrls: ['./mat-dialog-preview-entry.component.scss'],
  standalone: false,
})
export class MatDialogPreviewEntryComponent implements OnInit, OnDestroy {
  // VAR
  public apiUrl: string = environment.apiUrl + FLOW_GATEWAY;
  public params: any;

  public subscription: Subscription = new Subscription();

  constructor(
    public matDialogRef: MatDialogRef<MatDialogPreviewEntryComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      workstep: WHWorkStepDOM;
      type: string;
      targetId: string;
      disableUi: boolean;
    },
  ) {}

  public initParams(): any {
    return {
      page: 0,
      pageSize: 10,
      sort: 'materialNumber',
      sortMode: 'ASC',
      term: undefined,
    } as any;
  }

  ngOnInit() {
    this.params = this.initParams();
  }

  payloadEmmiter($event: any) {
    console.log($event);
  }

  public get materialIcon(): string {
    return WHIconENUM.MaterialConsumptionIcon as string;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
